import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@semsis/ui/Checkbox';
import { useConsent } from '../ConsentProvider';
import styles from './CookieConsent.module.css';

interface CookieConsentDetailsProps {
  onBack: () => void;
}

export function CookieConsentDetails({ onBack }: CookieConsentDetailsProps) {
  const { t } = useTranslation();
  const { preferences, savePreferences } = useConsent();
  const [analytics, setAnalytics] = useState(
    () => preferences?.categories.analytics ?? false,
  );
  const [sessionReplay, setSessionReplay] = useState(
    () => preferences?.categories.sessionReplay ?? false,
  );

  const handleSave = () => {
    savePreferences({ analytics, sessionReplay });
  };

  return (
    <div className={styles.details}>
      <div className={styles.details__inner}>
        <h3 className={styles.details__title}>{t('consent.detailsTitle')}</h3>

        <div className={styles.details__category}>
          <div className={styles.details__category_header}>
            <div>
              <span className={styles.details__category_name}>
                {t('consent.technicalName')}
              </span>
              <span className={styles.details__badge}>
                {t('consent.alwaysOn')}
              </span>
            </div>
            <Checkbox checked disabled />
          </div>
          <p className={styles.details__category_description}>
            {t('consent.technicalDescription')}
          </p>
        </div>

        <div className={styles.details__category}>
          <div className={styles.details__category_header}>
            <span className={styles.details__category_name}>
              {t('consent.analyticsName')}
            </span>
            <Checkbox
              checked={analytics}
              onCheckedChange={(checked) => {
                if (checked !== 'indeterminate') {
                  setAnalytics(checked);
                }
              }}
            />
          </div>
          <p className={styles.details__category_description}>
            {t('consent.analyticsDescription')}
          </p>
        </div>

        <div className={styles.details__category}>
          <div className={styles.details__category_header}>
            <span className={styles.details__category_name}>
              {t('consent.sessionReplayName')}
            </span>
            <Checkbox
              checked={sessionReplay}
              onCheckedChange={(checked) => {
                if (checked !== 'indeterminate') {
                  setSessionReplay(checked);
                }
              }}
            />
          </div>
          <p className={styles.details__category_description}>
            {t('consent.sessionReplayDescription')}
          </p>
        </div>

        <div className={styles.details__actions}>
          <button
            type="button"
            className={styles['banner__btn--primary']}
            onClick={handleSave}
          >
            {t('consent.savePreferences')}
          </button>
          <button
            type="button"
            className={styles.banner__btn}
            onClick={onBack}
          >
            {t('consent.back')}
          </button>
        </div>
      </div>
    </div>
  );
}
